import React, { PureComponent } from 'react';
import * as api from '../../../../services/api';
import TermsAndConditionsPage from '../../../presenters/TermsAndConditionsPage/TermsAndConditionsPage';
import LoadingWidget from '../../../widgets/LoadingWidget/LoadingWidget';
import { withRouter } from 'react-router-dom';
import { CUSTOMER_SIGNATURE_URL } from '../../../../route-names';
import {
  convertYearsToMonthsWord,
  convertYearsToMonths,
  convertYearsToWeeks
} from '../../../../utils/terms-and-conditions-util';
import { injectIntl } from 'react-intl';

const STANDARD = 'standard';
const FR = 'fr';

class TermsAndConditionsWrapper extends PureComponent {
  constructor(props) {
    super(props);

    const { renewal, customer, key, logo } = props.location.state;

    this.state = {
      loading: true,
      termsAndConditions: [],
      renewal,
      customer,
      key,
      logo,
      languageCode: customer.languageCode,
      hasFRLineItems: renewal.hasFrItems,
      hasStandardLineItems: renewal.hasStandardItems
    };

    this.loadInitialState = this.loadInitialState.bind(this);
    this.onAgree = this.onAgree.bind(this);
    this.interpolateText = this.interpolateText.bind(this);
    this.replacePlaceholder = this.replacePlaceholder.bind(this);
  }

  componentDidMount() {
    this.loadInitialState();
  }

  componentDidUpdate() {
    const {
      hasStandardLineItems,
      hasFRLineItems,
      standardHasBeenViewed,
      frHasBeenViewed
    } = this.state;

    if (
      (!hasStandardLineItems || standardHasBeenViewed) &&
      (!hasFRLineItems || frHasBeenViewed)
    ) {
      this.props.history.push({
        pathname: CUSTOMER_SIGNATURE_URL,
        state: {
          key: this.state.key,
          renewal: this.state.renewal,
          customer: this.state.customer,
          logo: this.state.logo
        }
      });
    }
  }

  onAgree(tandctype) {
    if (tandctype.toLowerCase() === STANDARD) {
      this.setState({
        standardHasBeenViewed: true
      });
    } else if (tandctype.toLowerCase() === FR) {
      this.setState({
        frHasBeenViewed: true
      });
    }

    window.scrollTo(0, 0);
  }

  loadInitialState() {
    api.terms
      .get(this.state.languageCode)
      .then((response) => {
        this.setState({
          loading: false,
          termsAndConditions: this.interpolateText(response.data)
        });
      })
      .catch((error) => {
        this.setState({ loading: false });
        throw Error('unable to download Terms and Conditions');
      });
  }

  displayedTermsAndConditions() {
    if (this.state.hasStandardLineItems && !this.state.standardHasBeenViewed) {
      return this.state.termsAndConditions.find(
        (tc) => tc.type.toLowerCase() === STANDARD
      );
    } else if (this.state.hasFRLineItems && !this.state.frHasBeenViewed) {
      return this.state.termsAndConditions.find(
        (tc) => tc.type.toLowerCase() === FR
      );
    } else return null;
  }

  replacePlaceholder(content) {
    const monthWord = convertYearsToMonthsWord(
      this.state.renewal.renewalTermYears
    );

    content = content.replaceAll(
      '<TERMS_MONTHS_WORD>',
      this.props.intl.formatMessage({
        id: monthWord
      })
    );
    content = content.replaceAll(
      '<TERMS_MONTHS_NUMBER>',
      convertYearsToMonths(this.state.renewal.renewalTermYears)
    );
    content = content.replaceAll(
      '<TERMS_WEEKS_NUMBER>',
      convertYearsToWeeks(this.state.renewal.renewalTermYears)
    );
    return content;
  }

  interpolateText(termsAndConditions) {
    if (termsAndConditions !== null) {
      termsAndConditions.forEach((terms) => {
        terms.sections.forEach((section) => {
          section.sectionContent = this.replacePlaceholder(
            section.sectionContent
          );
        });
      });     

      return termsAndConditions;
    }
  }

  showContent = () => {
    const content = this.displayedTermsAndConditions();

    return content != null ? (
      <TermsAndConditionsPage
        logo={this.state.logo}
        onAgree={this.onAgree}
        termsAndConditions={content}
      />
    ) : null;
  };

  render() {
    return (
      <div>{this.state.loading ? <LoadingWidget /> : this.showContent()}</div>
    );
  }
}

export default injectIntl(withRouter(TermsAndConditionsWrapper));
